import React from 'react';
import ModalTypeEnum from 'Modals/ModalConstants';
import BaseModal from 'Modals/BaseModal';
import PropTypes from 'prop-types';
import RecipientBuilderIntroModalBody from './RecipientBuilderIntroModalBody';

class RecipientBuilderIntroModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHidden: false,
    };
    this.onDecline = this.toggleHidden.bind(this, true);
    this.onCancel = this.toggleHidden.bind(this, false);
  }

  toggleHidden(isHidden) {
    this.setState({
      isHidden,
    });
  }

  render() {
    const hiddenModalStyle = {
      overlay: {
        display: 'none',
      },
      content: {
        display: 'none',
      },
    };

    return (
      <BaseModal
        activeModal={this.props.activeModal}
        modalStyle={this.state.isHidden ? hiddenModalStyle : null}
        bodyContent={
          <RecipientBuilderIntroModalBody
            close={this.props.close}
            documentType={this.props.documentType}
            shareKey={this.props.shareKey}
            onDecline={this.onDecline}
            onCancel={this.onCancel}
          />
        }
        closeModal={this.props.close}
        isOpen={this.props.isOpen}
        modalType={ModalTypeEnum.SELF_SERVE_RECIPIENT_BUILDER_INTRO}
        shouldCloseOnOverlayClick={false}
      />
    );
  }
}

RecipientBuilderIntroModal.defaultProps = {
  activeModal: '',
};

RecipientBuilderIntroModal.propTypes = {
  activeModal: PropTypes.oneOf([
    ModalTypeEnum.SELF_SERVE_RECIPIENT_BUILDER_INTRO,
    ModalTypeEnum.SELF_SERVE_RECIPIENT_BUILDER_FINISH,
    '',
  ]),
  close: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  shareKey: PropTypes.string.isRequired,
};

export default RecipientBuilderIntroModal;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/RecipientBuilderIntroModal/index.jsx